<template>
    <div class="graphics-filters">
        <div class="filters-grid">
            <div class="filter-wrapper">
                <el-select
                    v-model="localFilters.tourRouteIds"
                    multiple
                    filterable
                    clearable
                    placeholder="Rutas de inspección"
                    size="small"
                    @change="emitChange"
                >
                    <el-option
                        v-for="route in tourRoutes"
                        :key="route.id"
                        :label="route.name"
                        :value="route.id"
                    />
                </el-select>
            </div>

            <div class="filter-wrapper">
                <el-select
                    v-model="localFilters.crossCuttingIds"
                    multiple
                    filterable
                    clearable
                    placeholder="Criterios transversales"
                    size="small"
                    @change="emitChange"
                >
                    <el-option
                        v-for="criteria in crossCuttingCriteria"
                        :key="criteria.id"
                        :label="criteria.name"
                        :value="criteria.id"
                    />
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GraphicsFilters",
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        filtersData: {
            type: Object,
            default: () => ({
                tour_routes: [],
                cross_cutting_criteria: [],
            }),
        },
    },
    data() {
        return {
            localFilters: {
                tourRouteIds: [],
                crossCuttingIds: [],
                ...this.normalizeValue(this.value),
            },
        };
    },
    computed: {
        tourRoutes() {
            return (this.filtersData && this.filtersData.tour_routes) || [];
        },
        crossCuttingCriteria() {
            return (
                (this.filtersData && this.filtersData.cross_cutting_criteria) ||
                []
            );
        },
    },
    watch: {
        value: {
            handler(newValue) {
                this.localFilters = {
                    tourRouteIds: [],
                    crossCuttingIds: [],
                    ...this.normalizeValue(newValue),
                };
            },
            deep: true,
        },
    },
    methods: {
        normalizeValue(value = {}) {
            const normalized = { ...value };
            normalized.tourRouteIds = Array.isArray(value.tourRouteIds)
                ? value.tourRouteIds.slice()
                : value.tourRouteId
                ? [value.tourRouteId]
                : [];
            normalized.crossCuttingIds = Array.isArray(value.crossCuttingIds)
                ? value.crossCuttingIds.slice()
                : value.crossCuttingId
                ? [value.crossCuttingId]
                : [];
            return normalized;
        },
        emitChange() {
            this.$emit("input", {
                ...this.localFilters,
                tourRouteIds: this.localFilters.tourRouteIds.slice(),
                crossCuttingIds: this.localFilters.crossCuttingIds.slice(),
            });
        },
        clearField(field) {
            if (field === "tourRouteIds" || field === "crossCuttingIds") {
                this.localFilters[field] = [];
            } else if (field === "search") {
                this.localFilters[field] = "";
            } else {
                this.localFilters[field] = null;
            }
            this.emitChange();
        },
    },
};
</script>

<style scoped>
.graphics-filters {
    width: 100%;
}

.filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px;
}

.filter-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
</style>
